import FormattedMessage from 'I18n/components/FormattedMessage';
import { Button } from 'foundations-components/transitional/components/Button';
import { actions } from '../../constants/actions';
import { jsx as _jsx } from "react/jsx-runtime";
const DownloadInvoiceButton = ({
  onClickButton
}) => {
  return /*#__PURE__*/_jsx(Button, {
    "data-test-id": "download-btn",
    use: "tertiary-light",
    responsive: false,
    size: "extra-small",
    onClick: () => onClickButton(actions.DOWNLOAD),
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "invoices.components.invoiceActionsDropdown.buttons.download"
    })
  }, "download-btn");
};
export default DownloadInvoiceButton;